(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 768px)';
  var DESKTOP_MQ = '(min-width: 769px)';

  var state = {
    isOpen: false,
    savedItemCount: 0,
    lastTrigger: null,
    exitIntentToastShown: false,
    resumeToastTimer: null
  };

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function getCampaignRoot() {
    return document.querySelector('[data-campaign-landing]');
  }

  function getDrawer() {
    return document.querySelector('[data-recast-wizard-drawer]');
  }

  function getConfig() {
    var root = getCampaignRoot();
    if (!root) return {};
    return {
      resumeToastEnable: root.getAttribute('data-resume-toast-enable') !== 'false',
      resumeStickyEnable: root.getAttribute('data-resume-sticky-enable') !== 'false',
      trustBadgeEnable: root.getAttribute('data-drawer-trust-badge-enable') !== 'false',
      trustBadge: root.getAttribute('data-drawer-trust-badge') || '',
      wizardSectionId: root.getAttribute('data-wizard-section-id') || ''
    };
  }

  function updateCtaLabels(itemCount) {
    document.querySelectorAll('[data-campaign-cta]').forEach(function (cta) {
      var defaultLabel = cta.getAttribute('data-default-label');
      if (!defaultLabel) {
        defaultLabel = cta.textContent.trim();
        cta.setAttribute('data-default-label', defaultLabel);
      }
      cta.textContent = itemCount > 0 ? 'Continue my quote' : defaultLabel;
    });
  }

  function applyTrustBadge(drawer) {
    var config = getConfig();
    var badge = drawer.querySelector('[data-drawer-trust-badge]');
    if (!badge) return;
    if (config.trustBadgeEnable && config.trustBadge) {
      badge.textContent = config.trustBadge;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  function lockScroll() {
    var scrollY = window.scrollY;
    document.documentElement.classList.add('recast-scroll-lock');
    document.body.classList.add('recast-scroll-lock');
    document.body.style.top = '-' + scrollY + 'px';
    document.body.dataset.recastScrollY = String(scrollY);
  }

  function unlockScroll() {
    var scrollY = parseInt(document.body.dataset.recastScrollY || '0', 10);
    document.documentElement.classList.remove('recast-scroll-lock');
    document.body.classList.remove('recast-scroll-lock');
    document.body.style.top = '';
    delete document.body.dataset.recastScrollY;
    window.scrollTo(0, scrollY);
  }

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function trapFocus(container) {
    container.addEventListener('keydown', onFocusTrapKeydown);
  }

  function releaseFocus(container) {
    container.removeEventListener('keydown', onFocusTrapKeydown);
  }

  function onFocusTrapKeydown(e) {
    if (e.key !== 'Tab') return;
    var drawer = getDrawer();
    if (!drawer) return;
    var panel = drawer.querySelector('.recast-wizard-drawer__panel');
    if (!panel) return;
    var focusable = getFocusableElements(panel);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function showLoading(drawer, show) {
    var loading = drawer.querySelector('[data-drawer-loading]');
    var body = drawer.querySelector('[data-drawer-wizard-body]');
    if (loading) loading.hidden = !show;
    if (body) body.hidden = show;
  }

  function ensureResumeToast() {
    var existing = document.getElementById('recast-resume-toast');
    if (existing) return existing;

    var toast = document.createElement('div');
    toast.id = 'recast-resume-toast';
    toast.className = 'recast-resume-toast';
    toast.hidden = true;
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<p class="recast-resume-toast__message">Your trade-in is saved. Click here to resume your quote.</p>' +
      '<button type="button" class="recast-resume-toast__close" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(toast);

    toast.addEventListener('click', function (e) {
      if (e.target.closest('.recast-resume-toast__close')) {
        hideResumeToast();
        return;
      }
      hideResumeToast();
      openDrawer(state.lastTrigger, { expandCart: true });
    });

    toast.querySelector('.recast-resume-toast__close').addEventListener('click', function (e) {
      e.stopPropagation();
      hideResumeToast();
    });

    return toast;
  }

  function hideResumeToast() {
    var toast = document.getElementById('recast-resume-toast');
    if (toast) toast.hidden = true;
    if (state.resumeToastTimer) {
      clearTimeout(state.resumeToastTimer);
      state.resumeToastTimer = null;
    }
  }

  function showResumeToast(fromExitIntent) {
    var config = getConfig();
    if (!config.resumeToastEnable || state.savedItemCount === 0) return;
    if (fromExitIntent && state.exitIntentToastShown) return;

    var toast = ensureResumeToast();
    toast.hidden = false;

    if (fromExitIntent) state.exitIntentToastShown = true;

    if (state.resumeToastTimer) clearTimeout(state.resumeToastTimer);
    state.resumeToastTimer = window.setTimeout(hideResumeToast, 8000);
  }

  function expandWizardCart() {
    window.dispatchEvent(new CustomEvent('recast:expand-cart'));
  }

  function openDrawer(trigger, options) {
    var opts = options || {};
    var drawer = getDrawer();
    if (!drawer || state.isOpen) return;

    state.lastTrigger = trigger || state.lastTrigger;
    var expandCart = opts.expandCart === true || state.savedItemCount > 0;
    var loader = window.RecastWizardLoader;
    if (!loader) return;

    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    showLoading(drawer, true);

    var campaignRoot = getCampaignRoot();
    if (campaignRoot) campaignRoot.classList.add('campaign-lp--drawer-open');

    loader.loadWizardScripts()
      .then(function () {
        showLoading(drawer, false);
        applyTrustBadge(drawer);
        var wizardBody = drawer.querySelector('[data-drawer-wizard-body]');
        if (wizardBody) {
          loader.initAlpineInDrawer(wizardBody);
        }
        drawer.classList.add('is-open');
        lockScroll();
        trapFocus(drawer);

        if (!history.state || !history.state.recastWizardDrawer) {
          history.pushState({ recastWizardDrawer: true }, '', window.location.href);
        }

        state.isOpen = true;
        hideResumeToast();

        if (expandCart) {
          window.requestAnimationFrame(function () {
            expandWizardCart();
          });
        }

        var closeBtn = drawer.querySelector('.recast-wizard-drawer__close');
        if (closeBtn) closeBtn.focus();
      })
      .catch(function () {
        showLoading(drawer, false);
        alert('Unable to load the quote tool. Please refresh and try again.');
        closeDrawer(false);
      });
  }

  function closeDrawer(useHistoryBack) {
    var drawer = getDrawer();
    if (!drawer || !state.isOpen) return;

    var shouldToast = state.savedItemCount > 0;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    releaseFocus(drawer);
    unlockScroll();

    var campaignRoot = getCampaignRoot();
    if (campaignRoot) campaignRoot.classList.remove('campaign-lp--drawer-open');

    window.setTimeout(function () {
      drawer.hidden = true;
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 280);

    state.isOpen = false;

    if (useHistoryBack && history.state && history.state.recastWizardDrawer) {
      history.back();
    }

    if (state.lastTrigger && typeof state.lastTrigger.focus === 'function') {
      state.lastTrigger.focus();
    }

    if (shouldToast) {
      updateCtaLabels(state.savedItemCount);
      showResumeToast(false);
    }
  }

  function onOpenWizardClick(e) {
    var trigger = e.currentTarget;
    if (trigger.tagName === 'A') e.preventDefault();
    openDrawer(trigger);
  }

  function bindIntentLoaders() {
    var triggers = document.querySelectorAll('[data-recast-open-wizard]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', prefetchScripts, { passive: true });
      trigger.addEventListener('touchstart', prefetchScripts, { passive: true });
    });
  }

  function prefetchScripts() {
    if (window.RecastWizardLoader) {
      window.RecastWizardLoader.loadWizardScripts().catch(function () {});
    }
  }

  function bindOpenTriggers() {
    document.querySelectorAll('[data-recast-open-wizard]').forEach(function (el) {
      el.addEventListener('click', onOpenWizardClick);
    });
  }

  function bindDrawerClose() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeDrawer(true);
      });
    });
  }

  function bindEscape() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.isOpen) {
        closeDrawer(true);
      }
    });
  }

  function bindPopState() {
    window.addEventListener('popstate', function () {
      if (state.isOpen && (!history.state || !history.state.recastWizardDrawer)) {
        closeDrawer(false);
      }
    });
  }

  function bindCartUpdates() {
    window.addEventListener('recast:cart-updated', function (e) {
      state.savedItemCount = (e.detail && e.detail.itemCount) || 0;
      updateCtaLabels(state.savedItemCount);
    });
  }

  function bindExitIntent() {
    document.documentElement.addEventListener('mouseleave', function (e) {
      if (e.clientY > 0) return;
      if (!isDesktop()) return;
      if (state.isOpen) return;
      if (state.savedItemCount === 0) return;
      showResumeToast(true);
    });
  }

  function init() {
    var root = getCampaignRoot();
    if (!root || root.getAttribute('data-cta-behavior') !== 'open_wizard') return;
    if (!getDrawer()) return;
    if (root.getAttribute('data-wizard-bridge-ready') === 'true') return;
    root.setAttribute('data-wizard-bridge-ready', 'true');

    bindIntentLoaders();
    bindOpenTriggers();
    bindDrawerClose();
    bindEscape();
    bindPopState();
    bindCartUpdates();
    bindExitIntent();

    window.addEventListener('recast:open-wizard', function () {
      openDrawer();
    });

    var params = new URLSearchParams(window.location.search);
    var hash = window.location.hash || '';
    if (params.get('brand') || params.get('quote') === 'custom' || hash === '#custom-quote') {
      openDrawer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-campaign-landing]')
      : null;
    if (root) {
      root.removeAttribute('data-wizard-bridge-ready');
    }
    init();
  });
})();
